import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function Navbar() {
  const { user, logout } = useAuth();

  return (
    <nav className="bg-gray-900 border-b border-gray-800 px-8 py-4 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="text-white font-bold text-lg tracking-wide">GAMECHAIN</span>
        {user?.role === 'admin' && (
          <span className="bg-blue-600 text-white text-xs px-2 py-0.5 rounded-full">Admin</span>
        )}
        {user?.role === 'studio' && (
          <span className="bg-gray-700 text-gray-300 text-xs px-2 py-0.5 rounded-full">{user.gameId}</span>
        )}
      </div>
      <div className="flex items-center gap-4">
        <span className="text-gray-400 text-sm">{user?.email}</span>
        <button
          onClick={logout}
          className="text-gray-400 hover:text-white text-sm transition"
        >
          Sign out
        </button>
      </div>
    </nav>
  );
}